module.exports = __webpack_public_path__ + "static/img/1a (4).dd04b7ee.png";